export default "__VITE_ASSET__645ed017__"